// extracted by mini-css-extract-plugin
export default {"group":"group__1ghBF","title":"title__Eh+7s"};